import { GetSARsPayload } from 'app/modules/fincenSAR/requests';

const BASE = ['finCEN-SAR'] as const;

export const FINCEN_SAR_QUERY_KEYS = {
  getFinCENSAR: (id: number, useCacheEndpoint: boolean) =>
    [...BASE, 'sar', id, useCacheEndpoint] as const,
  getFilingNarrativeAuditTrail: (id: number) =>
    [...BASE, 'narrative', id, 'audit-trail'] as const,
  listFilingsAll: () => [...BASE, 'list'] as const,
  listFilings: (payload: GetSARsPayload, useCacheEndpoint: boolean) => {
    if (useCacheEndpoint) {
      return [
        ...FINCEN_SAR_QUERY_KEYS.listFilingsAll(),
        payload,
        'cached',
      ] as const;
    }
    return [...FINCEN_SAR_QUERY_KEYS.listFilingsAll(), payload] as const;
  },
};
